import { type ComponentType, type ReactElement, useMemo } from 'react';

import type { ContextMenuContainerProps } from '../../components/context_menu/types';
import TriggerContextMenu, {
  type ContextMenuWithOptions,
} from '../../components/trigger_context_menu/trigger_context_menu';
import VARIANTS from '../../constants/variants';
import type { ObjectWithId } from '../../types/common';
import Button from '../button/button';

type GearBoxTriggerButtonProps = {
  disabled?: boolean;
};

export function GearBoxTriggerButton({ disabled }: GearBoxTriggerButtonProps) {
  return (
    <Button
      noBorder
      disabled={disabled}
      wideBasis={false}
      variant={VARIANTS.WHITE}
      iconName="menu_context"
      aria={{
        label: 'More actions',
        haspopup: true,
      }}
    />
  );
}

type Props<Item extends ObjectWithId, State, Options> = {
  triggerElement?: ReactElement;
  contextItems?: Item[];
  contextMenu:
    | ComponentType<ContextMenuContainerProps<Item, State, Options>>
    | ContextMenuWithOptions<Item, State, Options>;
  showIcons?: boolean;
  disabled?: boolean;
};

const GearBoxActions = <Item extends ObjectWithId, State, Options>(
  props: Props<Item, State, Options>,
): ReactElement | null => {
  const memoizedTriggerElement = useMemo(
    () => <GearBoxTriggerButton disabled={props.disabled} />,
    [props.disabled],
  );
  const {
    triggerElement = memoizedTriggerElement,
    contextItems = [],
    contextMenu,
    showIcons = true,
  } = props;

  return (
    <TriggerContextMenu
      triggerElement={triggerElement}
      contextItems={contextItems}
      contextMenu={contextMenu}
      showIcons={showIcons}
    />
  );
};

export default GearBoxActions;
